import { ConectoresVersoes, ConectoresVersaoCadastro } from '@containers';
import { InfoUsuario } from '@utils';

const getPermissaoFila = (infoUsuario) => InfoUsuario.perm('admin') || InfoUsuario.perm('fila');

export default [
  {
    path: '/conectores/versoes',
    parent: '/conectores',
    text: 'Versões',
    match: /\/conectores\/versoes+$/,
    sider: true,
    component: ConectoresVersoes,
    exact: true,
    secret: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
  {
    path: '/conectores/versao/:nrBuild',
    text: 'Versão',
    component: ConectoresVersaoCadastro,
    secret: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
];
